import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'app/auth/service';
import { LoginComponent } from '../../common/login/login.component';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {

  public userInfo;

  constructor(
    public modalService: NgbModal,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.userInfo = this.authService.currentUserValue;
  }

  openLogin(){
    this.modalService.open(LoginComponent, {
      size: 'lg',
      centered: true
    });
  }

}
